import { useState } from "react";
import { Link } from "react-router-dom";
import { gossipFaqs } from "@/mocks/gossipFaqs";
import SectionHeading from "@/components/feature/SectionHeading";

export default function FaqPreview() {
  const [openIndex, setOpenIndex] = useState(0);
  const list = gossipFaqs.slice(0, 4);

  return (
    <section className="bg-background-100 py-14 md:py-16">
      <div className="mx-auto max-w-shell px-4 md:px-6">
        <SectionHeading
          eyebrow="FAQ"
          title="常见问题"
          description="关于更新频率、信源判断和内容边界，先把最常被问到的几件事说清楚。"
          action={
            <Link
              to="/faq"
              className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-4 py-2 text-sm text-foreground-700 transition-colors hover:border-primary-400 hover:text-primary-600"
            >
              全部问题 <i className="ri-arrow-right-line" />
            </Link>
          }
        />

        <div className="mt-8 overflow-hidden rounded-lg border border-background-200 bg-background-50">
          {list.map((item, index) => {
            const isOpen = openIndex === index;
            return (
              <div key={item.question} className="border-b border-background-200 last:border-0">
                <button
                  type="button"
                  onClick={() => setOpenIndex(isOpen ? -1 : index)}
                  aria-expanded={isOpen}
                  className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left transition-colors hover:bg-background-100"
                >
                  <span className="font-heading text-base font-bold text-foreground-950">{item.question}</span>
                  <i
                    className={`ri-add-line shrink-0 text-lg text-primary-600 transition-transform ${
                      isOpen ? "rotate-45" : ""
                    }`}
                  />
                </button>
                {isOpen && (
                  <p className="px-5 pb-5 text-sm leading-relaxed text-foreground-600">{item.answer}</p>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}